var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_vm._t("default"),_c(_vm.getComponent(_vm.item.component),_vm._g({tag:"component",attrs:{"list":_vm.item.data.tableData,"setting":_vm.item,"providerData":_vm.providerData.dynamicTabData}},_vm.$listeners))],2)}
var staticRenderFns = []

export { render, staticRenderFns }